import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

const SCRIPT_SRC = "https://payments.athmovil.com/api/modal/js/athmovil_base.js";

// Official ATH Móvil Business payment button. Each store uses its own public token.
// The order is created server-side (price recomputed) when the config loads; payment
// is always re-verified on the backend before the order is marked paid.
export default function AthmButton({ slug, cartToken, email, rep, promo, onPaid }) {
  const [cfg, setCfg] = useState(null);
  const [err, setErr] = useState(null);
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;
    api.post(`/public/store/${slug}/athm/config`, {
      cart_token: cartToken, email: email || "",
      rep_name: rep?.name || null, rep_phone: rep?.phone || null, promo_code: promo || null,
    }, { withCredentials: false })
      .then((r) => setCfg(r.data))
      .catch((e) => setErr(apiError(e)));
  }, [slug, cartToken]); // eslint-disable-line

  useEffect(() => {
    if (!cfg) return;
    const orderId = cfg.order_id;
    window.ATHM_Checkout = {
      env: "production", publicToken: cfg.publicToken, timeout: 600,
      theme: "btn", lang: "es", total: cfg.total, subtotal: cfg.subtotal, tax: cfg.tax,
      metadata1: cfg.metadata1, metadata2: cfg.metadata2, items: cfg.items || [], phoneNumber: "",
    };
    const confirm = async (reference) => {
      if (!reference) { toast.error("ATH Móvil no devolvió un número de referencia."); return; }
      try {
        await api.post("/public/athm/confirm", { slug, order_id: orderId, cart_token: cartToken, reference_number: String(reference) }, { withCredentials: false });
        toast.success("¡Pago recibido con ATH Móvil!");
        onPaid && onPaid(orderId);
      } catch (e) { toast.error(apiError(e)); }
    };
    window.authorizationATHM = (response) => {
      const ref = response?.referenceNumber || response?.data?.referenceNumber || window.ATHM_last_response?.referenceNumber;
      confirm(ref);
    };
    window.cancelATHM = () => { toast("Pago cancelado."); };
    window.expiredATHM = () => { toast("El pago expiró. Intenta de nuevo."); };
    let s = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (!s) { s = document.createElement("script"); s.src = SCRIPT_SRC; s.async = true; document.body.appendChild(s); }
    return () => { try { delete window.ATHM_Checkout; } catch { /* noop */ } };
  }, [cfg]); // eslint-disable-line

  if (err) return <p className="text-xs text-red-300" data-testid="athm-error">{err}</p>;
  if (!cfg) return <div className="flex items-center justify-center py-3 text-neutral-400" data-testid="athm-loading"><CircleNotch size={20} className="animate-spin" /></div>;
  return <div id="ATHMovil_Checkout_Button_payment" data-testid="athm-button" className="min-h-[52px]" />;
}
